"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var PIP_DEFAULT_WIDTH = 480;
// Embedders such as Electron webviews expose the API but cannot open the window,
// and a failed attempt consumes the user gesture needed by the native fallback.
var documentPictureInPictureBroken = /Electron/i.test(navigator.userAgent);
var getDocumentPictureInPicture = function () {
    var _a;
    if (documentPictureInPictureBroken)
        return null;
    return (_a = window.documentPictureInPicture) !== null && _a !== void 0 ? _a : null;
};
var copyStyleSheets = function (target) {
    Array.from(document.styleSheets).forEach(function (styleSheet) {
        try {
            var style = target.document.createElement('style');
            style.textContent = Array.from(styleSheet.cssRules).map(function (rule) { return rule.cssText; }).join('');
            target.document.head.appendChild(style);
        }
        catch (_a) {
            if (styleSheet.href) {
                var link = target.document.createElement('link');
                link.rel = 'stylesheet';
                link.href = styleSheet.href;
                target.document.head.appendChild(link);
            }
        }
    });
};
// Stremio Plus Windows shell: the window itself becomes a small always-on-top player (mpv keeps
// rendering), driven through win-set-pip / win-pip-changed.
var useShellPictureInPicture = function (shell) {
    var supported = shell.active && shell.capabilities.pictureInPicture;
    var _a = (0, react_1.useState)(false), active = _a[0], setActive = _a[1];
    var aspectRatio = (0, react_1.useRef)(16 / 9);
    var activeRef = (0, react_1.useRef)(false);
    activeRef.current = active;
    (0, react_1.useEffect)(function () {
        if (!supported)
            return;
        var onPipChanged = function (_a) {
            var active = _a.active;
            return setActive(active);
        };
        var onMpvPropChange = function (_a) {
            var name = _a.name, data = _a.data;
            if (name === 'video-params' && typeof (data === null || data === void 0 ? void 0 : data.aspect) === 'number' && data.aspect > 0) {
                aspectRatio.current = data.aspect;
            }
        };
        shell.on('win-pip-changed', onPipChanged);
        shell.on('mpv-prop-change', onMpvPropChange);
        return function () {
            shell.off('win-pip-changed', onPipChanged);
            shell.off('mpv-prop-change', onMpvPropChange);
        };
    }, [supported]);
    var setPip = (0, react_1.useCallback)(function (pip) {
        shell.send('win-set-pip', { pip: pip, aspectRatio: aspectRatio.current });
    }, [shell.send]);
    // Leaving the player gives the window back its normal size.
    (0, react_1.useEffect)(function () {
        return function () {
            if (activeRef.current)
                setPip(false);
        };
    }, [setPip]);
    var toggle = (0, react_1.useCallback)(function () { return setPip(!activeRef.current); }, [setPip]);
    var startDrag = (0, react_1.useCallback)(function () { return shell.send('win-start-drag'); }, [shell.send]);
    return { supported: supported, active: active, toggle: toggle, startDrag: startDrag };
};
// Document Picture-in-Picture (Chromium) moves the whole video container,
// so the subtitles rendered by stremio-video stay visible.
// Other browsers fall back to the native <video> Picture-in-Picture.
var usePictureInPicture = function (containerRef, manifest, onTogglePaused, shell) {
    var native = useShellPictureInPicture(shell);
    var _a = (0, react_1.useState)(false), active = _a[0], setActive = _a[1];
    var _b = (0, react_1.useState)(false), available = _b[0], setAvailable = _b[1];
    var pipWindow = (0, react_1.useRef)(null);
    var placeholder = (0, react_1.useRef)(null);
    var togglePausedRef = (0, react_1.useRef)(onTogglePaused);
    togglePausedRef.current = onTogglePaused;
    var getVideoElement = (0, react_1.useCallback)(function () {
        var _a, _b;
        return (_b = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('video')) !== null && _b !== void 0 ? _b : null;
    }, []);
    var restoreContainer = (0, react_1.useCallback)(function () {
        var _a;
        var container = containerRef.current;
        if (container && ((_a = placeholder.current) === null || _a === void 0 ? void 0 : _a.parentNode)) {
            placeholder.current.replaceWith(container);
        }
        placeholder.current = null;
        pipWindow.current = null;
        setActive(false);
    }, []);
    (0, react_1.useEffect)(function () {
        var videoElement = getVideoElement();
        var nativeSupported = document.pictureInPictureEnabled && videoElement !== null && !videoElement.disablePictureInPicture;
        setAvailable(videoElement !== null && (getDocumentPictureInPicture() !== null || nativeSupported));
        if (!videoElement)
            return;
        var onEnter = function () { return setActive(true); };
        var onLeave = function () { return setActive(false); };
        videoElement.addEventListener('enterpictureinpicture', onEnter);
        videoElement.addEventListener('leavepictureinpicture', onLeave);
        return function () {
            videoElement.removeEventListener('enterpictureinpicture', onEnter);
            videoElement.removeEventListener('leavepictureinpicture', onLeave);
        };
    }, [manifest]);
    var open = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var container, videoElement, documentPictureInPicture, ratio, target, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    container = containerRef.current;
                    videoElement = getVideoElement();
                    if (!container || !videoElement)
                        return [2 /*return*/];
                    documentPictureInPicture = getDocumentPictureInPicture();
                    if (!(documentPictureInPicture === null)) return [3 /*break*/, 2];
                    return [4 /*yield*/, videoElement.requestPictureInPicture()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
                case 2:
                    ratio = videoElement.videoWidth > 0 && videoElement.videoHeight > 0 ?
                        videoElement.videoHeight / videoElement.videoWidth
                        :
                            9 / 16;
                    _a.label = 3;
                case 3:
                    _a.trys.push([3, 5, , 7]);
                    return [4 /*yield*/, documentPictureInPicture.requestWindow({
                            width: PIP_DEFAULT_WIDTH,
                            height: Math.round(PIP_DEFAULT_WIDTH * ratio),
                        })];
                case 4:
                    target = _a.sent();
                    return [3 /*break*/, 7];
                case 5:
                    error_1 = _a.sent();
                    documentPictureInPictureBroken = true;
                    if (!document.pictureInPictureEnabled)
                        throw error_1;
                    return [4 /*yield*/, videoElement.requestPictureInPicture()];
                case 6:
                    _a.sent();
                    return [2 /*return*/];
                case 7:
                    copyStyleSheets(target);
                    target.document.body.style.cssText = 'margin: 0; background: black; overflow: hidden;';
                    container.style.position = 'absolute';
                    container.style.inset = '0';
                    placeholder.current = document.createComment('picture-in-picture');
                    container.replaceWith(placeholder.current);
                    target.document.body.appendChild(container);
                    target.document.body.addEventListener('click', function () { return togglePausedRef.current(); });
                    target.addEventListener('pagehide', function () {
                        container.style.position = '';
                        container.style.inset = '';
                        restoreContainer();
                    });
                    pipWindow.current = target;
                    setActive(true);
                    return [2 /*return*/];
            }
        });
    }); }, [restoreContainer]);
    var close = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!pipWindow.current) return [3 /*break*/, 1];
                    pipWindow.current.close();
                    return [3 /*break*/, 3];
                case 1:
                    if (!document.pictureInPictureElement) return [3 /*break*/, 3];
                    return [4 /*yield*/, document.exitPictureInPicture()];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }, []);
    var toggle = (0, react_1.useCallback)(function () {
        (active ? close() : open()).catch(function (error) {
            console.error('Picture-in-Picture:', error);
        });
    }, [active, open, close]);
    // The container must be back in the main document before React unmounts it.
    (0, react_1.useLayoutEffect)(function () {
        return function () {
            var target = pipWindow.current;
            restoreContainer();
            target === null || target === void 0 ? void 0 : target.close();
            if (document.pictureInPictureElement) {
                document.exitPictureInPicture().catch(function (error) {
                    console.error('Picture-in-Picture:', error);
                });
            }
        };
    }, []);
    if (native.supported) {
        return { available: true, active: native.active, toggle: native.toggle, native: true, startDrag: native.startDrag };
    }
    return { available: available, active: active, toggle: toggle, native: false, startDrag: function () { return undefined; } };
};
exports.default = usePictureInPicture;
